import React from "react";

import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import { Header } from "./Header/Header";
import { LayoutProps } from "./Layout.props";
import { Sidebar } from "./Sidebar/Sidebar";
import { selectCurrentLanguage } from "@src/store/app_manager/selector";

export const DRAWER_WIDTH = 270;

const AppLayout: React.FC<LayoutProps> = (props: LayoutProps) => {
  const { children } = props;

  const language = useSelector(selectCurrentLanguage);

  const [open, setOpen] = React.useState(true);

  const toggleDrawer = React.useCallback((): void => {
    setOpen((prevState) => !prevState);
  }, []);

  return (
    <React.Fragment>
      <Box display="flex" height="100%">
        <Header open={open} language={language} />
        <Sidebar language={language} open={open} toggleDrawer={toggleDrawer} />

        <Box mt="50px" width="100%" p="25px 40px" position="relative">
          {children}
        </Box>
      </Box>
    </React.Fragment>
  );
};

export const Layout = React.memo(AppLayout);

export const withLayout = <T extends Record<string, unknown>>(
  Component: React.FC<T>
) => {
  return function withLayoutComponent(props: T): JSX.Element {
    return (
      <Layout>
        <Component {...props} />
      </Layout>
    );
  };
};
